import {
  useSiteSettingsAndMetadata,
  UseSiteSettingsAndMetadata,
} from './useSiteSettingsAndMetadata'

export type SiteSettings = NonNullable<UseSiteSettingsAndMetadata['sanitySiteSettings']>
export type UseSiteSettings = SiteSettings

export const useSiteSettings = (): UseSiteSettings => {
  const { sanitySiteSettings } = useSiteSettingsAndMetadata()
  return sanitySiteSettings ?? {}
}
